import React, { useState, useEffect, useRef } from 'react';
import {
  Grid,
  TextField,
  Typography,
  MenuItem,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Collapse,
  IconButton,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  ChevronLeft,
  ChevronRight,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from '@material-ui/icons';

import CloseIcon from '@material-ui/icons/Close';
// import { fetchAlpatiaDefaultSettings } from '../../../../../containers/actions/ecosystemActions';
// import usePrevious from '../../../../pcmp/components/helpers/previousProps';
import { useDispatch, useSelector } from 'react-redux';
// import { Autocomplete } from '@material-ui/lab';
// import { updateOrgProfile } from '../../../../../containers/actions/userActions';
// import BackDrop from '../../../../../components/pcmp/components/common/models/BackDrop';
// import BackDrop from '../../models/BackDrop';
import Backdrop from '@material-ui/core/Backdrop';
import { UPDATE_ORG_PROFILE } from '../../../../../../containers/actions/types';
// import CheckCircleIcon from '@material-ui/icons/CheckCircle';
// import { UPDATE_ORG_FAIL } from '../../../../../containers/actions/types';
// import { Country, State, City } from 'country-state-city';
// import postalCodes from 'postal-codes-js';

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: '#F5F9FF',
  },
  titleGrid: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem',
    backgroundColor: '#F5F9FF',
  },
  head: {
    textAlign: 'center',
  },
  closeBtn: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: '12px',
    right: '10px',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
      color: '#FF0000',
    },
  },

  content: {
    marginTop: theme.spacing(2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },

  inline: {
    fontSize: '1.5rem',
    display: 'inline',
    fontWeight: 600,
    marginBottom: '0.5rem',
  },
  hrLine: {
    backgroundColor: 'grey',
    width: '2.5rem',
    height: '3px',
    margin: 'inherit',
    marginBottom: '1rem',
    marginTop: '0.25rem',
  },
  hr: {
    border: '0.5px solid #000000de',
    marginTop: '3rem',
    marginBottom: '2rem',
    width: '100%',
    borderBottom: 'thick',
  },
  textfieldWidth: {
    width: '85%',
    marginTop: '8px',
  },
  hideDropdown: {
    '& .MuiAutocomplete-popupIndicator': {
      display: 'none',
    },
    '& .MuiAutocomplete-clearIndicator': {
      display: 'none',
    },
  },
  hideDeleteIcon: {
    '& .MuiChip-deleteIcon': {
      display: 'none',
    },

    color: '#000000',
    border: '1px solid #000000',
    marginRight: '4px',
  },

  required: {
    color: 'red',
    marginLeft: '4px',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    fontWeight: 600,
  },
  input: {
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&[type=number]': {
      '-moz-appearance': 'textfield',
    },
    // Additional styles to disable scrolling
    overflow: 'hidden',
    pointerEvents: 'none', // Prevents pointer events on the input
    touchAction: 'none', // Disables touch actions
    userSelect: 'none', // Disables text selection
    resize: 'none', // Prevents resizing
  },
  dialogContent: {
    textAlign: 'center',
    padding: '24px 36px 24px 36px',
  },
  avatar: {
    color: 'green',
    margin: '0 auto',
    fontSize: '54px',
  },
  dialogActions: {
    justifyContent: 'center',
    marginTop: theme.spacing(2),
  },
}));

const ViewShipmentAddressesScreen = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { openDialog, closeViewShipmentAddresses, fetchedData } = props;

  const [shipmentAddressDetails, setShipmentAddressDetails] = useState({
    DeliveryStreetAddress1: fetchedData?.delivery_address
      ? fetchedData.delivery_address.street_address_1
      : '',
    DeliveryStreetAddress2: fetchedData?.delivery_address
      ? fetchedData.delivery_address.street_address_2
      : '',
    PickupStreetAddress1: fetchedData?.pickup_address
      ? fetchedData.pickup_address.street_address_1
      : '',
    PickupStreetAddress2: fetchedData?.pickup_address
      ? fetchedData.pickup_address.street_address_2
      : '',
  });

  const handleCancel = () => {
    dispatch({
      type: UPDATE_ORG_PROFILE,
      payload: {},
    });
    closeViewShipmentAddresses();
  };

  return (
    <>
      <Backdrop />
      <Dialog open={openDialog} fullScreen>
        <DialogTitle style={{ padding: '0px' }}>
          <Grid item xs={12} className={classes.header}>
            <Grid item xs={12} className={classes.titleGrid}>
              <Grid item xs={12} className={classes.head}>
                <Typography variant='h6' style={{ fontSize: '1.875rem' }}>
                  View Shipment Address 
                </Typography>
                <Typography>
                  Please update the Address in the field below.
                </Typography>
              </Grid>
            </Grid>

            <Grid item xs={2} sm={2} md={2}>
              <Typography
                variant='body2'
                className={classes.closeBtn}
                onClick={handleCancel}
              >
                Cancel{' '}
                <CloseIcon style={{ fontSize: '35px', color: '#FF0000' }} />
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent
          style={{
            paddingLeft: '140px',
            paddingTop: '32px',
          }}
        >
          
            <>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant='body2' className={classes.inline}>
                    Pickup Address
                  </Typography>
                  <hr className={classes.hrLine} />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    Street Address 1
                  </Typography>
                  <Typography>
                    {shipmentAddressDetails.PickupStreetAddress1}
                  </Typography>
                </Grid>
                
                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    Street Address 2
                  </Typography>
                  {shipmentAddressDetails.PickupStreetAddress2}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    City
                  </Typography>
                  <Typography>{fetchedData.city}</Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    State
                  </Typography>
                  <Typography>{fetchedData.state}</Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    Post Code
                  </Typography>
                  <Typography>{fetchedData.pincode}</Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    Country
                  </Typography>
                  <Typography>{fetchedData.country}</Typography>
                </Grid>

              </Grid>

            <Grid container spacing={3}>
                <Grid item xs={11}>
                  <hr className={classes.hr} />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant='body2' className={classes.inline}>
                    Delivery Address
                  </Typography>
                  <hr className={classes.hrLine} />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    Street Address 1
                  </Typography>
                  <Typography>
                    {shipmentAddressDetails.DeliveryStreetAddress1}
                  </Typography>
                </Grid>
                
                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    Street Address 2
                  </Typography>
                  {shipmentAddressDetails.DeliveryStreetAddress2}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    City
                  </Typography>
                  <Typography>{fetchedData.city}</Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    State
                  </Typography>
                  <Typography>{fetchedData.state}</Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    Post Code
                  </Typography>
                  <Typography>{fetchedData.pincode}</Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    Country
                  </Typography>
                  <Typography>{fetchedData.country}</Typography>
                </Grid>

              </Grid>
            </>
          
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ViewShipmentAddressesScreen;
